import { api } from './index'; // Import the base API

export const deleteEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteDestination: builder.mutation({
      query: (id) => ({
        url: `destinations/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "AdminDestinationList", id: "AdminDestinationList" },
      ],
    }),

    deleteDestinationImages: builder.mutation({
      query: (ids) => ({
        url: `destinations/images`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: ids
      }),
      invalidatesTags: [{ type: "DestinationImages", id: "DestinationImages" }, { type: "AdminDestinationList", id: "AdminDestinationList" }],
    }),

    deleteAdventure: builder.mutation({
      query: (id) => ({
        url: `adventures/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "AdminAdventureList", id: "AdminAdventureList" },
      ],
    }),

    deleteProgramme: builder.mutation({
      query: (id) => ({
        url: `programmes/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "AdminProgrammeList", id: "AdminProgrammeList" },
      ],
    }),

    deleteProgrammeAdventures: builder.mutation({
      query: (adventureIds) => ({
        url: `programmes/adventures`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          programmeAdventureIds: adventureIds
        }
      }),
      invalidatesTags: [
        { type: "AdminProgrammeList", id: "AdminProgrammeList" },
        { type: "ProgrammeAdventures", id: "ProgrammeAdventures" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useDeleteDestinationMutation,
  useDeleteDestinationImagesMutation,
  useDeleteAdventureMutation,
  useDeleteProgrammeMutation,
  useDeleteProgrammeAdventuresMutation
  // ... export other hooks ...
} = deleteEndpoints;
